var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAntivirus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 505 505",
    style: {
      enableBackground: "new 0 0 505 505"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#90DFAA",
      opacity: 0
    },
    cx: 252.5,
    cy: 252.5,
    r: 252.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C9984",
      opacity: 0
    },
    d: "M66.3,423c46.2,50.4,112.5,82,186.2,82s140.1-31.6,186.2-82H66.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.9,
    y: 362.3,
    style: {
      fill: "#40596B"
    },
    width: 99.2,
    height: 41.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 202.9,
    y: 362.3,
    style: {
      fill: "#9FB5C4"
    },
    width: 99.2,
    height: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FB5C4"
    },
    d: "M327.8,403.6H177.2c-0.3,0-0.6,0.3-0.6,0.6v18.3c0,0.3,0.3,0.6,0.6,0.6h150.6c0.3,0,0.6-0.3,0.6-0.6 v-18.3C328.4,403.9,328.1,403.6,327.8,403.6z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#40596B"
    },
    d: "M411.4,108H93.6c-2.1,0-3.8,1.7-3.8,3.8v246.8c0,2.1,1.7,3.8,3.8,3.8h317.8c2.1,0,3.8-1.7,3.8-3.8 V111.8C415.2,109.7,413.5,108,411.4,108z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 126.1,
    style: {
      fill: "#FFFFFF"
    },
    width: 289.2,
    height: 191.6
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M315.6,161.6c-28.2,4.6-53.9-12.1-62.2-18.1c-0.5-0.4-1.3-0.4-1.8,0c-8.2,6-34,22.7-62.2,18.1 c-0.8-0.1-1.6,0.4-1.6,1.2V208c0,0,1.4,64.7,64.1,92.5c0.4,0.2,0.9,0.2,1.3,0c62.7-27.9,64.1-92.5,64.1-92.5v-45.2 C317.2,162,316.4,161.5,315.6,161.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M303.3,224.1c2-8.6,2.2-14.5,2.3-15.2v-35.3c-1.1,0.1-2.2,0.1-3.3,0.1c-21.5,0-40.1-10.2-49.7-16.6 l0,0v67H303.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M252.5,157c-9.6,6.4-28.2,16.6-49.7,16.6l0,0c-1.1,0-2.2,0-3.3-0.1v35.1c0,0.2,0.2,6.3,2.4,15.3h50.6 V157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M201.9,224.1c4.3,18,16.5,47.3,50.6,63.5v-63.5H201.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M252.5,224.1v63.5l0,0c34.5-16.3,46.5-45.6,50.8-63.5H252.5z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntivirus);
export default __webpack_public_path__ + "static/media/Antivirus.d6759a50462c7c15ad5951a25a4f5b7b.svg";
export { ForwardRef as ReactComponent };